import { TOGGLE_AUTH_MODAL } from "./ActionTypes";

export const toggleAuthModal = (name, onSuccess) => ({
  type: TOGGLE_AUTH_MODAL,
  payload: {
    name,
    onSuccess,
  },
});
